import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import CookieBanner from "@/components/CookieBanner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-bg text-ink relative">
      <Header />
      <main className="flex-1 pt-20 md:pt-24 relative z-10">{children}</main>
      <Footer />
      <CartDrawer />
      <WhatsAppFAB />
      <CookieBanner />
    </div>
  );
};

export default Layout;
